import { apiWithAuth, apiWithoutAuth } from "./utils";

export class Auth {
  constructor(private readonly mountPath: string) {}

  async authenticate(userData : { [key: string]: any }) {
    return await apiWithoutAuth.post(`${this.mountPath}/login`, userData);
  }

  async getUserInfo() {
    return await apiWithAuth.get(`${this.mountPath}`);
  }

  async forgotPassword(identifier: string) {
    return await apiWithoutAuth.post(`${this.mountPath}/forget-password`, { identifier });
  }

  async resetPassword(resetToken: string, newPassword: string) {
    return await apiWithoutAuth.post(`${this.mountPath}/reset-password`, { resetToken, newPassword });
  }

}
